

import TelaMapaFeiraMobile from '../../Vendas/TelaMapaFeiraMobile';

const MapaMobile = () => {

  return (
    <div className="modulo-vendas-container">
         <div className="app-frame">
           <div className="layout">
            <TelaMapaFeiraMobile />
           </div>
         </div>
     </div>
  );
};

export default MapaMobile;